var _style, _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartner02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 70",
    style: {
      enableBackground: "new 0 0 100 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EA2330;}\r\n\t.st1{opacity:0.7;}\r\n\t.st2{fill:url(#SVGID_1_);}\r\n\t.st3{fill:url(#SVGID_2_);}\r\n\t.st4{fill:url(#SVGID_4_);}\r\n\t.st5{fill:url(#SVGID_5_);}\r\n\t.st6{fill:url(#SVGID_6_);}\r\n\t.st7{clip-path:url(#SVGID_7_);}\r\n\t.st8{fill:#072F54;}\r\n\t.st9{fill:#FBC108;}\r\n\t.st10{fill:#525A68;}\r\n\t.st11{fill:#5C0D34;}\r\n\t.st12{fill:#757F8B;}\r\n\t.st13{fill:#F48F00;}\r\n\t.st14{fill:#007FAD;}\r\n\t.st15{fill:#C94A30;}\r\n\t.st16{fill:#CDD0D2;}\r\n\t.st17{fill:none;}\r\n\t.st18{fill:#4272FC;}\r\n\t.st19{fill:#231F20;}\r\n\t.st20{fill:#DB3939;}\r\n\t.st21{fill:#FF5A5F;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(1.25,0,0,-1.25,-347.07005,505.1865)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 267.66,
    y: 362.01,
    width: 100,
    height: 28.28
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_1_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14",
    style: {
      clipPath: "url(#SVGID_1_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g20",
    transform: "translate(313.0154,387.4258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22",
    className: "st8",
    d: "M3.16-17.67H0.68c-0.01,0-0.02,0-0.02,0.01l-2.14,2.61l-2.14-2.61c0-0.01-0.01-0.01-0.02-0.01 h-1.99c-0.01,0-0.02,0.01-0.03,0.02c0,0.01,0,0.02,0,0.03l3.15,3.87l-3.11,3.83C-5.63-9.9-5.63-9.89-5.63-9.88 c0.01,0.01,0.02,0.02,0.03,0.02h2.48c0.01,0,0.02,0,0.02-0.02l1.88-2.32l1.91,2.33C0.69-9.87,0.7-9.86,0.71-9.86h2.02 c0.01,0,0.02-0.01,0.03-0.02c0.01-0.01,0-0.03,0-0.04l-2.95-3.55l3.37-4.15c0.01-0.01,0.01-0.02,0.01-0.03 C3.18-17.66,3.17-17.67,3.16-17.67"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g24",
    transform: "translate(325.1013,393.2106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path26",
    className: "st8",
    d: "M4.5-17.02c-1.1,0-1.85-0.67-2.06-1.83h3.74v0.07C6.18-17.85,5.49-17.02,4.5-17.02 M8.1-20.04 c-0.01-0.01-0.02-0.01-0.03-0.01H2.4c0.12-1.32,0.98-2.08,2.37-2.08c0.86,0,1.76,0.29,3.05,0.98c0.02,0.01,0.05-0.01,0.05-0.03 l0-1.75c0-0.01-0.01-0.02-0.02-0.03c-1.19-0.5-2.39-0.85-3.34-0.85c-2.45,0-4.22,1.78-4.22,4.24s1.77,4.24,4.22,4.24 c2.23,0,3.66-1.5,3.66-3.57C8.17-19.24,8.11-20.01,8.1-20.04"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g28",
    transform: "translate(338.7259,395.8986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path30",
    className: "st8",
    d: "M6.01-16.73c-0.7,0-1.26,0.56-1.26,1.24c0,0.71,0.57,1.28,1.26,1.28s1.26-0.57,1.26-1.28 C7.28-16.17,6.71-16.73,6.01-16.73 M4.99-26.14c-0.02,0-0.03,0.01-0.03,0.03v7.74c0,0.02,0.01,0.03,0.02,0.03h2.05 c0.02,0,0.03-0.02,0.03-0.03v-7.74c0-0.02-0.01-0.03-0.03-0.03H4.99z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g32",
    transform: "translate(316.3916,388.4746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path34",
    className: "st8",
    d: "M3.53-17.55c-0.37,0-0.75,0.05-1.18,0.17l0,4.96c0.51,0.16,0.95,0.24,1.39,0.24 c1.42,0,2.38-1.05,2.38-2.61C6.12-16.46,5.11-17.55,3.53-17.55 M4.09-10.6c-0.58,0-1.16-0.11-1.78-0.32H0.27 c-0.02,0-0.03-0.01-0.03-0.03v-12.69c0.62,0.08,1.37,0.3,2.11,0.83l0,3.86c0.5-0.07,0.92-0.12,1.32-0.12 c2.8,0,4.6,1.68,4.6,4.27C8.27-12.32,6.55-10.6,4.09-10.6"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g36",
    transform: "translate(334.4465,389.053)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path38",
    className: "st8",
    d: "M5.54-17.49c-0.64-0.34-1.21-0.49-1.75-0.49c-1.27,0-2.02,0.89-2.02,2.39 c0,1.73,0.97,2.85,2.47,2.85c0.41,0,0.82-0.1,1.3-0.32V-17.49z M5.54-7.39v-4.05c-0.6,0.17-1.13,0.25-1.66,0.25 c-2.43,0-4.27-1.83-4.27-4.27c0-2.42,1.62-4.18,3.85-4.18c0.77,0,1.49,0.19,2.34,0.63l0-0.7c0.56,0.11,1.21,0.33,1.84,0.78 v12.37C7.02-6.65,6.28-6.86,5.54-7.39"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g40",
    transform: "translate(346.0656,389.0668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path42",
    className: "st8",
    d: "M6.83-17.48c-0.62-0.36-1.15-0.53-1.62-0.53c-1.36,0-2.17,0.89-2.17,2.39 c0,1.71,0.96,2.85,2.38,2.85c0.38,0,0.84-0.15,1.41-0.45L6.83-17.48z M8.94-11.41c0,0.05-0.04,0.09-0.09,0.09l-1.66,0 c-0.05,0-0.09-0.04-0.09-0.09v-0.28H7.06C6.29-11.36,5.64-11.21,5-11.21c-2.29,0-4.09-1.9-4.09-4.34c0-2.46,1.61-4.11,4-4.11 c0.64,0,1.46,0.04,2.23,0.93v-1c0.54,0.12,1.18,0.35,1.79,0.78L8.94-11.41z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g44",
    transform: "translate(299.994,389.1686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path46",
    className: "st8",
    d: "M1.71-17.47l5.15,0c-0.08-0.58-0.27-1.25-0.72-1.94H1.72H0.84H0.78 c-0.66,0-1.19,0.51-1.26,1.15c0,0.01-0.01,0.02-0.01,0.03v5.27v4.88c0,0.01,0,0.02,0.01,0.03c0.06,0.64,0.6,1.15,1.26,1.15 c0.02,0,0.04,0,0.06,0l6.01,0C6.77-7.47,6.58-8.16,6.13-8.85H1.71v-2.76h4.37c0.02,0,0.03-0.01,0.03-0.03v-1.92 c0-0.02-0.01-0.03-0.03-0.03H1.71V-17.47L1.71-17.47z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g48",
    transform: "translate(294.1932,387.2835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path50",
    className: "st8",
    d: "M1.07-17.68c-0.51,0-0.82,0.4-0.82,0.88c0,0.52,0.36,0.88,0.82,0.88 c0.46,0,0.82-0.36,0.82-0.88C1.88-17.32,1.53-17.68,1.07-17.68 M1.07-15.81c-0.52,0-0.97-0.39-0.97-0.98 c0-0.56,0.4-0.98,0.97-0.98c0.51,0,0.96,0.39,0.96,0.98C2.03-16.21,1.58-15.81,1.07-15.81"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "g52",
    transform: "translate(293.9853,388.1523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path54",
    className: "st8",
    d: "M1.04-17.59v0.36h0.24c0.12,0,0.27-0.02,0.27-0.17c0-0.18-0.13-0.19-0.29-0.19H1.04z  M1.73-17.42c0,0.23-0.14,0.33-0.42,0.33H0.87v-1.16h0.19v0.5h0.18l0.3-0.5h0.22l-0.33,0.51C1.6-17.71,1.73-17.63,1.73-17.42"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "g56",
    transform: "translate(349.4863,393.2892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path58",
    className: "st8",
    d: "M7.21-17.02c-0.51,0-0.83,0.4-0.83,0.88c0,0.52,0.36,0.88,0.83,0.88 c0.46,0,0.82-0.36,0.82-0.88C8.03-16.65,7.67-17.02,7.21-17.02 M7.21-15.15c-0.52,0-0.97-0.39-0.97-0.98 c0-0.56,0.4-0.98,0.97-0.98c0.51,0,0.96,0.39,0.96,0.98C8.17-15.54,7.72-15.15,7.21-15.15"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "g60",
    transform: "translate(349.2775,394.1585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path62",
    className: "st8",
    d: "M7.19-16.92v0.36h0.24c0.12,0,0.27-0.02,0.27-0.17c0-0.18-0.13-0.19-0.28-0.19H7.19z  M7.87-16.75c0,0.23-0.14,0.33-0.42,0.33H7.01v-1.16H7.2v0.5h0.18l0.3-0.5H7.9l-0.33,0.51C7.75-17.05,7.87-16.96,7.87-16.75"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "g64",
    transform: "translate(288.2157,396.9411)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path66",
    className: "st8",
    d: "M0.4-16.61l-0.37,1.06l-3.17,4.23l0.57,0.14l5.46-4.72l3.21,0.92 c0.38,0.1,0.81,0.12,1.13,0.12c-1.01,2.18-2.86,3.97-5.3,4.83c-4.82,1.72-10.13-0.8-11.84-5.63c-0.53-1.49-0.66-3.03-0.43-4.5 l7.7,2.67L0.4-16.61z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "g68",
    transform: "translate(294.6721,397.7614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path70",
    className: "st8",
    d: "M1.12-16.52c-0.28-0.18-0.7-0.42-1.11-0.56l-3.22-0.92l-2.15-6.9l-0.56-0.18l0.45,5.27 l-0.25,1.09l-3.02-0.86l-7.98-1.88c0.63-3.07,2.8-5.74,5.97-6.87c4.82-1.72,10.13,0.8,11.84,5.62 C1.85-20.62,1.8-18.45,1.12-16.52"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "g72",
    transform: "translate(288.5209,395.7888)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path74",
    className: "st9",
    d: "M0.44-16.74l0.25-1.09L0.24-23.1l0.56,0.18l2.15,6.9l3.22,0.92c0.41,0.13,0.83,0.37,1.11,0.56 c-0.1,0.28-0.21,0.56-0.34,0.83c-0.33,0-0.76-0.02-1.13-0.12l-3.21-0.92l-5.46,4.72l-0.57-0.14l3.17-4.23l0.37-1.06l-3.04-0.87 l-7.7-2.67c0.02-0.16,0.05-0.32,0.08-0.48l7.98,1.88L0.44-16.74z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner02);
export default __webpack_public_path__ + "static/media/partner-02.ca95ab2b3d0c773f2c2ae456df15a656.svg";
export { ForwardRef as ReactComponent };